export default __webpack_public_path__ + "static/media/KOD0133-min.1dc5a76e.webp";